import React, { useState } from "react";
import { connect, ConnectedProps } from "react-redux";

import { RESOURCE_IDS, resourceName } from "../../../lib/enums";
import ResourceSquare from "../../ResourceSquare";
import { closeDialog, sellItem } from "../../../store/actions";

const AMOUNT_LIMIT = 500;

const timers:{[key: string]: NodeJS.Timeout | null} = {
  checkAmount: null,
};

interface IProps {
  type: string;
  marketUsage: number;
}

const mapStateToProps = (state: any) => ({
  race: state.governorate.race,
  resources: state.governorate.resources,
  marketLimit: state.governorate.marketLimit,
  marketUsage: state.governorate.marketUsage,
});

const mapDispatchToProps = (dispatch: any) => ({
  sellItemDispatch: (
    resourceId: number | string,
    amount: number,
    marketType: string
  ) => dispatch(sellItem(resourceId, amount, marketType)),
  closeDialogDispatch: () => dispatch(closeDialog())
})

const connector = connect(mapStateToProps, mapDispatchToProps);

const SellItem = ({
  type,
  marketLimit,
  marketUsage,
  race,
  resources,
  sellItemDispatch,
  closeDialogDispatch
}: IProps & ConnectedProps<typeof connector>) => {
  const [selected, setSelected] = useState<string | undefined>(["grain", "stone", "iron", "bricks", "weapons", "mana"].find(name => resources[name] > 0));
  const [amount, setAmount] = useState(0);

  const changeAmount = (newAmount: string) => {
    if (marketUsage >= marketLimit || !selected || (Number.isNaN(Number.parseInt(newAmount, 10)) && newAmount !== "*")
      || Number.parseInt(newAmount, 10) < 0) {
      setAmount(0);
      return;
    }

    const limit = resources[selected];
    const validatedAmount = newAmount === "*"
      ? limit
      : Math.min(Number.parseInt(newAmount, 10), limit, AMOUNT_LIMIT, marketLimit - marketUsage);
    setAmount(validatedAmount);
  }

  return (
    <div>
      <div className="dialog-content">
        <div className="row persons news news-square magic-level js-resources">
          <ResourceSquare
            resource={resources.grain}
            icon="obili"
            race={race.name}
            first={true}
            selected={selected === resourceName.GRAIN}
            select={() => (resources.grain > 0 && setSelected(resourceName.GRAIN))}
          />
          <ResourceSquare
            resource={resources.stone}
            icon="kameni"
            race={race.name}
            selected={selected === resourceName.STONE}
            select={() => resources.stone > 0 && setSelected(resourceName.STONE)}
          />
          <ResourceSquare
            resource={resources.bricks}
            icon="infrastrukturni-body"
            race={race.name}
            selected={selected === resourceName.BRICKS}
            select={() => resources.bricks > 0 && setSelected(resourceName.BRICKS)}
          />
          <ResourceSquare
            resource={resources.iron}
            icon="zelezo"
            race={race.name}
            selected={selected === resourceName.IRON}
            select={() => resources.iron > 0 && setSelected(resourceName.IRON)}
          />
          <ResourceSquare
            resource={resources.weapons}
            icon="zbrane"
            race={race.name}
            selected={selected === resourceName.WEAPONS}
            select={() => resources.weapons > 0 && setSelected(resourceName.WEAPONS)}
          />
          <ResourceSquare
            resource={resources.mana}
            icon="mana"
            race={race.name}
            selected={selected === resourceName.MANA}
            select={() => resources.mana > 0 && setSelected(resourceName.MANA)}
          />
        </div>
        <table className="table">
          <tr>
            <td>Amount</td>
            <td>
              <input type="tel" name="amount" className="input"
                     onChange={(event) => {
                       setAmount(!Number.isNaN(Number.parseInt(event.target.value, 10))
                         ? Number.parseInt(event.target.value, 10) : 0)
                       if (timers.checkAmount) {
                         clearTimeout(timers.checkAmount);
                       }
                       timers.checkAmount = setTimeout(() => changeAmount(event.target.value), 200);
                     }}
                     value={amount}
                     style={{ display: "inline-block" }}
              />
            </td>
          </tr>
        </table>
        <p className="negative"/>
      </div>
      <footer className="dialog-footer">
        <a
          className="btn btn-blank btn-no-width"
          onClick={closeDialogDispatch}
        >
          Cancel
        </a>
        <button
          className="btn btn-blank btn-no-width"
          onClick={() => selected && sellItemDispatch(RESOURCE_IDS[selected], amount, type)}
        >
          Sell
        </button>
      </footer>
    </div>
  );
};

export default connector(SellItem);
